import {FieldsI18n} from '@/locales/base.message.locales';

export const fields: FieldsI18n = {
  auth: {
    email: 'Email',
    password: 'Senha',
    password_confirmation: 'Confirmação de senha',
    current_password: 'Senha atual',
  },
  user: {
    first_name: 'Nome',
    last_name: 'Sobrenome',
    about: 'Sobre',
    birth: 'Data de nascimento',
    city: 'Cidade de Residência',
    country_of_residence: 'País de residencia',
    created_or_belongs_to_company: 'Você criou ou pertence a uma empresa ?',
    gender: 'Genero',
    nationality: 'Nacionalidade',
    student_or_graduate: 'Você é estudante ou recém formado ?',
    whats_your_profile: 'Qual é o seu perfil ?',
  },
  contact: {
    email: 'Email*',
    message: 'Mensagem*',
    name: 'Nome completo*',
    subject: 'Assunto*',
  },
  validations: {
    equals: '{0} Precisa ser a mesma',
    invalid_email: 'Email inválido',
    max_length: 'Máximo de {0} caracteres',
    min_length: 'Mínimo de  {0} caracteres',
    password: 'Senha',
    required: 'Campo é Obrigatório',
  },
  topic: {
    description: 'Descrição',
    title: 'Título',
  },
};
